import styled from 'styled-components';

export const StyledTargetingContainer = styled.div`
	padding: 15px 0 28px 0;
`;